import { Box, Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router';
import { useAcceptEventSla } from '../hooks/useEventSla';
import { useState } from 'react';

export const EventSlaPage = () => {
  const navigate = useNavigate();
  const acceptSla = useAcceptEventSla();
  const [isImgLoaded, setIsImgLoaded] = useState(false);
  const goBack = () => navigate(-1);
  const openEvent = async () => {
    await acceptSla();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Typography
        sx={{
          fontSize: 20,
          fontWeight: 500,
          color: '#3b4559',
          pl: 7.5,
          pr: 7.5,
          pt: 10,
        }}
      >
        <FormattedMessage id='home.label.events' />
      </Typography>
      <Box
        sx={{ py: 10 }}
        component='img'
        src='/public/assets/images/event_sla.svg'
        onLoad={() => setIsImgLoaded(true)}
      />
      {isImgLoaded && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            px: '10%',
            height: '100%',
            pb: 40,
          }}
        >
          <Typography
            sx={{ fontSize: 24, fontWeight: 600, mb: 10, textAlign: 'center' }}
          >
            <FormattedMessage id='resources.event.opt-in-title' />
          </Typography>
          <Typography sx={{ mb: 5, alignSelf: 'flex-start' }}>
            <FormattedMessage id='resources.event.opt-in-desc' />
          </Typography>
        </Box>
      )}
      {isImgLoaded && (
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            fontSize: 16,
            px: '15%',
            py: 10,
            justifyContent: 'space-between',
          }}
        >
          <Button
            variant={'outlined'}
            disableElevation
            onClick={goBack}
            sx={{
              width: '45%',
              borderRadius: 8,
              px: 11,
              mr: 4,
              py: 4,
              fontSize: 'inherit',
            }}
          >
            <FormattedMessage id='action.sla.later' />
          </Button>
          <Button
            variant={'contained'}
            disableElevation
            onClick={openEvent}
            sx={{
              width: '45%',
              borderRadius: 8,
              ml: 4,
              px: 11,
              py: 4,
              fontSize: 'inherit',
            }}
          >
            <FormattedMessage id='action.accept' />
          </Button>
        </Box>
      )}
    </Box>
  );
};
